import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PolymerModule } from '@codebakery/origami';
import { LayoutComponent } from './layout/layout.component';
import { SummaryDetailTemplateComponent } from './summary-detail-template/summary-detail-template.component';
import { SummaryAssetsComponent } from './summary-assets/summary-assets.component';
import { SummaryControllersComponent } from './summary-controllers/summary-controllers.component';
import { SummaryBNAsComponent } from './summary-bnas/summary-bnas.component';
import { SummaryGraphicAbstractComponent } from './summary-graphic-abstract/summary-graphic-abstract.component';
import { SummaryFunctionalDescriptionComponent } from './summary-functional-description/summary-functional-description.component';
import { SummaryMeteringHierarchyComponent } from './summary-metering-hierarchy/summary-metering-hierarchy.component';
import { SummaryQbFileComponent } from './summary-qb-file/summary-qb-file.component';
import { SummaryAntiVirusVersionReportComponent } from './summary-anti-virus-version-report/summary-anti-virus-version-report.component';
import { SummaryFirewallConnectionsStatusReportComponent } from './summary-firewall-connections-status-report/summary-firewall-connections-status-report.component';
import { SummaryEwsHealthCheckReportComponent } from './summary-ews-health-check-report/summary-ews-health-check-report.component';
import { SummaryTableComponent } from './summary-table/summary-table.component';
import { SiteService, EBIService, ContextDiscoveryEventBusService } from './../context-discovery-services/services/';
import { SummaryLoadingComponent } from './summary-loading/summary-loading.component';
import { SummaryDescriptionDMSComponent } from './summary-description-dms/summary-description-dms.component';
import { AggregatorUtil } from '../context-discovery-services/util';

@NgModule({
  imports: [
    CommonModule,
    PolymerModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [LayoutComponent, SummaryDetailTemplateComponent, SummaryAssetsComponent,
    SummaryControllersComponent, SummaryBNAsComponent, SummaryGraphicAbstractComponent,
    SummaryFunctionalDescriptionComponent, SummaryMeteringHierarchyComponent,
    SummaryQbFileComponent, SummaryAntiVirusVersionReportComponent,
    SummaryFirewallConnectionsStatusReportComponent, SummaryEwsHealthCheckReportComponent,
    SummaryTableComponent,
    SummaryLoadingComponent,
    SummaryDescriptionDMSComponent],
  exports: [LayoutComponent],
  providers: [
    SiteService,
    EBIService,
    ContextDiscoveryEventBusService,
    AggregatorUtil
  ]
})
export class SummaryModule { }
